<template>
  <div class="">
    <regulations-and-privacy v-if="privacyFirst" />
    <div class="d-flex justify-content-center">
      <div>
        <router-link
          class="login-link"
          :to="{ name: 'login' }"
          @click="closeMenu"
          v-if="!hideLogin"
        >
          <button class="btn btn-block login-button auth-login mb-1">
            <login-icon /> <span>Zaloguj się</span>
          </button>
        </router-link>
        <router-link
          class="d-flex justify-content-end"
          :to="{ name: 'forgot-password' }"
          @click="closeMenu"
          v-if="!hideResetPassword"
          ><div class="mb-3">Zapomniałem hasła</div></router-link
        >
        <router-link
          class="register-link"
          :to="{ name: 'register' }"
          @click="closeMenu"
          v-if="!hideRegistration"
        >
          <button class="btn btn-block login-button auth-login mb-2">
            <registration-icon /> <span>Zarejestruj się</span>
          </button>
        </router-link>
        <form action="/accounts/facebook/login/" method="post" class="mb-2">
          <input type="hidden" name="csrfmiddlewaretoken" :value="csrf" />
          <button
            class="btn btn-block login-button facebook-login"
            type="submit"
          >
            <facebook-icon />
            <span>Zaloguj przez Facebook</span>
          </button>
        </form>
        <form
          action="/accounts/google/login/"
          method="post"
          class=""
          ref="google-form"
        >
          <input type="hidden" name="csrfmiddlewaretoken" :value="csrf" />
          <button
            class="btn btn-block login-button google-login"
            type="submit"
            @click="sendEventBeforeLogin"
          >
            <google-icon />
            <span>Zaloguj przez Google</span>
          </button>
        </form>
      </div>
    </div>
    <regulations-and-privacy v-if="!privacyFirst" />
  </div>
</template>
<script>
import GoogleIcon from "@/components/icons/GoogleIcon";
import FacebookIcon from "@/components/icons/FacebookIcon";
import { mapGetters, mapMutations } from "vuex";
import LoginIcon from "@/components/icons/LoginIcon";
import RegulationsAndPrivacy from "@/accounts/RegulationsAndPrivacy";
import RegistrationIcon from "@/components/icons/RegistrationIcon.vue";
import { sendGTMEvent } from "@/utils";

export default {
  components: {
    RegistrationIcon,
    RegulationsAndPrivacy,
    GoogleIcon,
    FacebookIcon,
    LoginIcon,
  },
  props: {
    hideLogin: {
      type: Boolean,
      default: false,
    },
    hideResetPassword: {
      type: Boolean,
      default: false,
    },
    hideRegistration: {
      type: Boolean,
      default: false,
    },
    privacyFirst: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapMutations(["closeMenu"]),
    sendEventBeforeLogin(event) {
      event.preventDefault();
      const form = this.$refs["google-form"];
      sendGTMEvent({ event: "rejestracja", "login-method": "google" }, () => {
        form.submit();
      });
    },
  },
  computed: {
    ...mapGetters("accounts", ["csrf"]),
    ...mapGetters(["getRegulations", "getPrivacyPolicy"]),
  },
};
</script>
<style scoped>
.login-button {
  text-decoration: none;
  border-radius: 10px;
  align-items: center;
  height: 45px;
  max-width: 400px;
  min-width: 300px;
  width: 100%;
  cursor: pointer;
  padding-left: 10px;
  display: flex;
  font-weight: bold;
}

.auth-login {
  background-color: white;
  color: black;
  border: 1px solid black;
}

.google-login {
  background-color: white;
  color: gray;
  border: 1px solid grey;
}

.facebook-login {
  background-color: rgba(24, 119, 242, 1);
  color: white;
}

.login-button span {
  margin-left: 25px;
}

.google-login:active {
  background-color: gray;
  color: white;
}

.facebook-login:active {
  color: rgba(24, 119, 242, 1);
  background-color: white;
  border: 1px solid rgba(24, 119, 242, 1);
}

.login-link,
.register-link {
  text-decoration: none;
}
</style>
